import { Navigate, useOutletContext } from "react-router-dom";
import { Loader2, GraduationCap } from "lucide-react";

export default function ParentHome() {
  const { schools } = useOutletContext();
  if (schools === null) return <div className="flex-1 flex items-center justify-center py-20" data-testid="parent-home"><Loader2 className="h-6 w-6 animate-spin text-slate-400" /></div>;
  const first = schools.flatMap((s) => s.students)[0];
  if (first) return <Navigate to={`/parent/student/${first.id}`} replace />;
  const firstClient = schools.flatMap((s) => s.clients || [])[0];
  if (firstClient) return <Navigate to={`/parent/client/${firstClient.id}`} replace />;
  return (
    <div className="flex-1 flex items-center justify-center p-8" data-testid="parent-home">
      <div className="rounded-2xl bg-white p-8 text-center shadow-sm max-w-sm">
        <div className="mx-auto h-12 w-12 rounded-xl bg-primary/10 text-primary flex items-center justify-center mb-3"><GraduationCap className="h-6 w-6" /></div>
        <div className="font-display font-bold text-slate-900">No one linked yet</div>
        <p className="text-sm text-slate-500 mt-1">Ask your school or care facility for an invite link — your family members will appear in the menu once linked.</p>
      </div>
    </div>
  );
}
